export const knowledgeBaseCardoConfig = {
  xsmall: {
    // when not overlaid, direction
    contentAlignment: {
      horizontal: 'middle',
      vertical: 'bottom', // if middle then verticalOffsetType is invalid
    },
    gridSetup: {
      image: {
        columns: 16,
      },
      content: {
        columns: 14,
      },
      card: {
        columns: 16,
      },
    },
  },
  medium: {
    contentOverlay: {
      coverImage: false,
      verticalOffsetType: 'outside',
      horizontalOffset: false,
    },
    gridSetup: {
      card: {
        columns: 8,
      },
    },
  },
};
